<template>
    <div class="pictureCropper-container">
      <div class="cropper-content-box" :style="{height: cropperHeight, width: cropperWidth}">

        <VueCropper  ref="cropper"  :img="option.img"  :outputSize="option.outputSize"  :outputType="option.outputType"  :info="option.info"  :canScale="option.canScale"  :autoCrop="option.autoCrop"  :autoCropWidth="option.autoCropWidth"  :autoCropHeight="option.autoCropHeight"  :fixed="option.fixed"  :fixedNumber="option.fixedNumber"  :full="option.full"  :canMove="option.canMove"  :canMoveBox="option.canMoveBox"  :original="option.original"  :centerBox="option.centerBox"  :height="option.height"  :infoTrue="option.infoTrue"  :maxImgSize="option.maxImgSize"  :enlarge="option.enlarge"  :mode="option.mode"  @realTime="realTime"
        >
        </VueCropper>
      </div>

      <el-radio-group v-model="resource" style="padding-top:20px" @change="qiehuan">
        <el-radio label="1:1"></el-radio>
        <el-radio label="1.25:1"></el-radio>
        <el-radio label="2.35:1（封面）"></el-radio>
        <el-radio label="2.5:1（轮播图）"></el-radio>
        <el-radio label="任意比例"></el-radio>
      </el-radio-group>

      </div>
  </template>
   
  <script>
  import { VueCropper } from 'vue-cropper'
  export default {
    name: 'index',
    components:{
      VueCropper,
    },
    props:{
      initialImg:{
        type: String,
        default: ""
      },
      cropperWidth:{
        type: String,
        default: '200px'
      },
      cropperHeight:{
        type: String,
        default: '200px'
      },
      autoCropWidth:{
        type:Number,
        default: 200,
      },
      autoCropHeight:{
        type:Number,
        default: 200,
      },
    },
    watch:{
      initialImg:{
        deep: true,
        immediate: true,
        handler(val){
          this.option.img = val
        }
      }
    },
    data(){
      return {
        previews: {},
        resource:'2.35:1（封面）',
        option: {
          img: this.initialImg,//裁剪图片的地址
          outputSize: 1,//裁剪生成图片的质量(可选0.1 - 1)
          outputType: 'png',//裁剪生成图片的格式（jpeg || png || webp）
          info: true,//图片大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 300, // 默认生成截图框宽度
          autoCropHeight: 300, // 默认生成截图框高度
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [1, 1], // 截图框的宽高比例
          full: false, // false按原比例裁切图片，不失真
          canMove: false, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          height: false, // 是否按照设备的dpr 输出等比例图片
          infoTrue: false, // true为展示真实输出图片宽高，false展示看到的截图框宽高
          maxImgSize: 3000, // 限制图片最大宽度和高度
          enlarge: 1 // 图片根据截图框输出比例倍数
        },
      }
    },
    methods: {
      qiehuan(){ 
        if(this.resource == '1:1'){
          this.option.fixed = true;
          this.option.fixedNumber = [1, 1];
          this.$nextTick(()=>{
            this.$refs.cropper.goAutoCrop();
          })
        }else if(this.resource == '1.25:1'){
          this.option.fixed = true;
          this.option.fixedNumber = [1.25, 1];
          this.$nextTick(()=>{
            this.$refs.cropper.goAutoCrop();
          })
        }else if(this.resource == '2.35:1（封面）'){
          this.option.fixed = true;
          this.option.fixedNumber = [2.35, 1];
          this.$nextTick(()=>{
            this.$refs.cropper.goAutoCrop();
          })
        }else if(this.resource == '2.5:1（轮播图）'){
          this.option.fixed = true;
          this.option.fixedNumber = [2.5, 1];
          this.$nextTick(()=>{
            this.$refs.cropper.goAutoCrop();
          })
        }else if(this.resource == '任意比例'){
          this.option.fixed = false;
          this.$nextTick(()=>{
            this.$refs.cropper.goAutoCrop();
          })
        }
      },
      // 实时预览函数
      realTime (data) {
        this.previews = data;
        this.$emit('picturePreview',data);
      },
      // 获取截图base64格式
      getBase64(){
        return new Promise(resolve => {
          this.$refs.cropper.getCropData((data) => {
            resolve(data)
          })
        })
      },
    // 获取图片blob格式
      getBlob(){
        return new Promise(resolve => {
            this.$refs.cropper.getCropBlob((data) => {
            resolve(data)
            })
        })
      },

      //获取图片file格式
      getfile(base64,name){
        return new Promise(resolve => {
            this.$refs.cropper.getCropData((data) => {
                resolve(this.convertToBinary(base64,name));
          })
        })
      },
    
    convertToBinary(file,name) {  
      let arr = file.split(',');
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, {
        type: mime
      });
    }
    },
    mounted() {
      this.option.fixedNumber = [1.25, 1]
    }
  }
  </script>